(function () {
  if (window.customElements.get('ma-cart')) return;

  var ROOT = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';

  function parse(html, selector) {
    try {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    } catch (error) {
      return null;
    }
  }

  function swap(targetSelector, html, sourceSelector) {
    var target = document.querySelector(targetSelector);
    if (!target) return;
    var source = parse(html, sourceSelector || targetSelector);
    if (source) target.innerHTML = source.innerHTML;
  }

  class MaCart extends HTMLElement {
    constructor() {
      super();
      this.busy = false;
      this.noteTimer = null;
    }

    connectedCallback() {
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('input', this.onInput.bind(this));
    }

    get sectionId() {
      return this.dataset.sectionId || 'ma-cart';
    }

    onClick(event) {
      var step = event.target.closest('[data-cart-step]');
      if (step) {
        event.preventDefault();
        var row = step.closest('[data-line]');
        var field = row && row.querySelector('[data-cart-qty]');
        if (!field) return;
        var next = parseInt(field.value, 10) + parseInt(step.getAttribute('data-cart-step'), 10);
        if (isNaN(next) || next < 0) next = 0;
        field.value = next;
        this.update(row.getAttribute('data-line'), next);
        return;
      }

      var remove = event.target.closest('[data-cart-remove]');
      if (remove) {
        event.preventDefault();
        var line = remove.closest('[data-line]');
        if (line) this.update(line.getAttribute('data-line'), 0);
      }
    }

    onChange(event) {
      var field = event.target.closest('[data-cart-qty]');
      if (!field) return;
      var row = field.closest('[data-line]');
      var value = parseInt(field.value, 10);
      if (isNaN(value) || value < 0) value = 0;
      field.value = value;
      if (row) this.update(row.getAttribute('data-line'), value);
    }

    onInput(event) {
      var note = event.target.closest('[data-cart-note]');
      if (!note) return;
      clearTimeout(this.noteTimer);
      var value = note.value;
      this.noteTimer = setTimeout(function () {
        fetch(ROOT + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: value })
        });
      }, 600);
    }

    update(line, quantity) {
      if (this.busy || !line) return;
      this.busy = true;
      this.classList.add('is-busy');

      var self = this;
      var sections = [this.sectionId, 'cart-icon-bubble', 'cart-drawer'].join(',');

      fetch(ROOT + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          line: line,
          quantity: quantity,
          sections: sections,
          sections_url: window.location.pathname
        })
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (!data || !data.sections) {
            window.location.reload();
            return;
          }

          var own = data.sections[self.sectionId];
          if (own) {
            var body = parse(own, '[data-cart-body]');
            var target = self.querySelector('[data-cart-body]');
            if (body && target) target.innerHTML = body.innerHTML;
          }

          if (data.sections['cart-icon-bubble']) {
            swap('#cart-icon-bubble', data.sections['cart-icon-bubble'], '#shopify-section-cart-icon-bubble');
          }

          if (data.sections['cart-drawer']) {
            swap('cart-drawer', data.sections['cart-drawer'], '#shopify-section-cart-drawer cart-drawer');
          }

          document.dispatchEvent(new CustomEvent('ma:cart:update', { detail: { cart: data } }));
        })
        .catch(function () {
          window.location.reload();
        })
        .finally(function () {
          self.busy = false;
          self.classList.remove('is-busy');
        });
    }
  }

  window.customElements.define('ma-cart', MaCart);
})();
